import { render, staticRenderFns } from "./PlatformLeft.vue?vue&type=template&id=1ea42fa8&scoped=true"
import script from "./PlatformLeft.vue?vue&type=script&lang=js"
export * from "./PlatformLeft.vue?vue&type=script&lang=js"
import style0 from "./PlatformLeft.vue?vue&type=style&index=0&id=1ea42fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea42fa8",
  null
  
)

export default component.exports